/* eslint no-cond-assign: 0 */
import { getOffset } from 'utils/util';

export default {
  getSliderValueX(mouseEvent, totalValue, isFullScreen, sliderElement) {
    const pageX   = mouseEvent.nativeEvent? mouseEvent.nativeEvent.pageX : mouseEvent.pageX;
    if(isFullScreen === true) {
      const offsetWidth = (mouseEvent.currentTarget === document) ? document.documentElement.offsetWidth: mouseEvent.currentTarget.offsetWidth,
      mousePosition = pageX,
      sliderPercent = mousePosition / offsetWidth;
      return totalValue * sliderPercent;
    } else {
      const percentScrubbed = (((pageX - getOffset(sliderElement, document).left) / sliderElement.offsetWidth)),
            seekTo = percentScrubbed * totalValue;
      return seekTo;
    }
  },
  getSliderValueY(mouseEvent, totalValue) {
    const pageY         = mouseEvent.nativeEvent? mouseEvent.nativeEvent.pageY : mouseEvent.pageY,
          mousePosition = pageY - this.findPos(mouseEvent.currentTarget)[1],
          sliderPercent = (mousePosition / mouseEvent.currentTarget.offsetHeight);
    return  (totalValue - (totalValue * sliderPercent));
  },
  findPos(obj) {
    if(obj === document) {
      return [0, 0];
    }
    let curleft = 0;
    let curtop = 0;
    let object = obj;
    if(obj.offsetParent) {
      do {
          curleft += object.offsetLeft;
          curtop += object.offsetTop;
      } while ((object = object.offsetParent) !== null);
      return [curleft, curtop];
    }
  }
};



/** WEBPACK FOOTER **
 ** ./modules/mixins/has_slider_events.js
 **/